var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-obs-department-question',{staticClass:"pt-obs-department-question__withData",attrs:{"allCitys":_vm.allCitys,"allMembers":_vm.allMembers}})}
var staticRenderFns = []

export { render, staticRenderFns }